<template>
    <div class="">
        <div class="d-flex align-items-center justify-content-between">
            <div>
                <ol class="breadcrumb fs-sm mb-1">
                    <li class="breadcrumb-item"><router-link to="/dashboard">Dashboard</router-link></li>
                    <li class="breadcrumb-item active" aria-current="page">Users</li>
                </ol>

                <label class="form-label"> <h4>Users</h4></label>
            </div>
            <div class="d-flex align-items-center">
                <select
                    class="form-select form-select-sm me-2 status-filter"
                    v-model="meta.status"
                    @change="search()"
                >
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                </select>
                <Search
                                class="me-2"
                                :class="{ 'is-invalid': errors?.district_id }"
                                :customClass="{ 'is-invalid': errors?.district_id }"
                                :initialize="meta.district_id"
                                id="district_id"
                                label="district"
                                placeholder="Select District"
                                :data=" all_districts"
                                @input="district => { meta.district_id = district; search(); }"
                            >
                            </Search>
            <router-link to="/users/create" type="submit" class="btn  align-item-center btn-primary me-2">
                <i class="ri-add-line me-1"></i>
                ADD USER
            </router-link>
        </div>
        </div>
        <div class="card br-16 card-shadow">
            <div class="card-body">
                <div class="form-group mb-2 d-flex">
                    <input class="form-control form-control-sm" type="text" placeholder="Type keyword and press enter key" v-model="meta.search" @keypress.enter="search()" />
                </div>
                <div class="table-responsive table-responsive-sm" style="height: 415px; overflow-x: hidden; overflow-y: scroll;">
                    <table class="table table-sm text-nowrap table-bordered mb-0">
                        <thead>
                            <tr>
                                <th class="text-center">#</th>
                                <th @click="sort('employee_id')">
                                    Employee Id
                                    <span>
                                        <i v-if="meta.keyword == 'employee_id' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                        <i v-else-if="meta.keyword == 'employee_id' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                        <i v-else class="fas fa-sort"></i>
                                    </span>
                                </th>
                                <th @click="sort('name')">
                                    Name
                                    <span>
                                        <i v-if="meta.keyword == 'name' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                        <i v-else-if="meta.keyword == 'name' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                        <i v-else class="fas fa-sort"></i>
                                    </span>
                                </th>
                                <th @click="sort('email')">
                                    Email
                                    <span>
                                        <i v-if="meta.keyword == 'email' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                        <i v-else-if="meta.keyword == 'email' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                        <i v-else class="fas fa-sort"></i>
                                    </span>
                                </th>
                                <th @click="sort('role')">
                                    Role
                                    <span>
                                        <i v-if="meta.keyword == 'role' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                        <i v-else-if="meta.keyword == 'role' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                        <i v-else class="fas fa-sort"></i>
                                    </span>
                                </th>
                                <th @click="sort('mobile_no')">
                                    Mobile No.
                                    <span>
                                        <i v-if="meta.keyword == 'mobile_no' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                        <i v-else-if="meta.keyword == 'mobile_no' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                        <i v-else class="fas fa-sort"></i>
                                    </span>
                                </th>
                                <th>Assigned District</th>
                                <th class="text-center">Status</th>
                                <th class="text-center">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="users.length == 0">
                                <td colspan="11" class="text-center">No records found</td>
                            </tr>
                            <tr v-for="(user, key) in users" :key="key">
                                <td class="text-center">{{ meta.from + key }}</td>
                                <td>{{ user.employee_id }}</td>
                                <td>{{ user.name }}</td>
                                <td>{{ user.email }}</td>
                                <td>{{ user.role }}</td>
                                <td>{{ user.mobile_no}}</td>
                                <td class="district-col">
                                    <template v-if="getDistrictNames(user)">
                                        <div v-if="!expandedDistricts[user.user_id]" class="district-collapsed">
                                            <span
                                                class="district-text"
                                                :ref="'districtText-' + user.user_id"
                                            >{{ getDistrictNames(user) }}</span>
                                            <a
                                                v-if="overflowDistricts[user.user_id]"
                                                href="javascript:void(0)"
                                                class="district-toggle"
                                                @click.prevent="toggleDistrict(user.user_id)"
                                            >View more</a>
                                        </div>
                                        <div v-else class="text-wrap">
                                            {{ getDistrictNames(user) }}
                                            <a
                                                href="javascript:void(0)"
                                                class="district-toggle"
                                                @click.prevent="toggleDistrict(user.user_id)"
                                            >View less</a>
                                        </div>
                                    </template>
                                </td>
                                <td class="text-center">
                                    <div class="form-switch form-switch">
                                        <input class="form-check-input" type="checkbox" role="switch" :id="'user' + user.user_id" :checked="user.deleted_at ? 0 : 1" :value="user.deleted_at ? 0 : 1" @change="deleteUser(user)" />
                                        <label class="custom-control-label" :for="'user' + user.user_id"></label>
                                    </div>
                                </td>
                                <td class="text-center">
                                    <nav v-if="!user.deleted_at">
                                        <a href="javascript:void(0)" class="text-success me-2" @click.prevent="edit(user)"><i class="ri-pencil-line fs-18 lh-1"></i></a>
                                        <!-- <a href="javascript:void(0)" class="text-danger" data-bs-toggle="modal" data-bs-target="#exampleModal" @click="district_assign(user)" ><i class="ri-map-pin-user-fill fs-18 lh-1"></i></a> -->
                                    </nav>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="mt-3">
            <div class="d-flex justify-content-between align-items-center">
                <select class="form-select from-select-sm width-75" v-model="meta.per_page" @change="onPerPageChange">
                    <option>10</option>
                    <option>15</option>
                    <option>20</option>
                    <option>25</option>
                    <option>30</option>
                </select>
                <span>Showing {{ meta.from }} to {{ meta.to }} of {{ meta?.totalRows }} entries</span>
                <Pagination :maxPage="meta.maxPage" :totalPages="meta.lastPage" :currentPage="meta.page" @pagechanged="onPageChange" />
            </div>
        </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" data-bs-backdrop="static" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5" id="exampleModalLabel">Assign Districts</h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="closeModal"></button>
                </div>
                <div class="modal-body">
                    <MultiSelect v-model="district_ids" optionLabel="district" :options="districts" placeholder="Select District" :maxSelectedLabels="3" style="width: 100%; height: 37px;" :style="errors?.district_id ? error_style : ''" />

                    <span v-if="errors?.district_id" class="invalid-feedback">{{ errors.district_id[0] }}</span>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    <button type="button" class="btn btn-primary" @click="submitdistricts()">Save changes</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Pagination from "@/components/Pagination.vue";
import MultiSelect from "primevue/multiselect";
import Search from "@/components/Search.vue";
    export default {
        components: { Pagination, MultiSelect,Search },
        data() {
            return {
                meta: {
                    search: "",
                    order_by: "asc",
                    keyword: "user_id",
                    per_page: 10,
                    totalRows: 0,
                    page: 1,
                    lastPage: 1,
                    from: 1,
                    to: 1,
                    maxPage: 1,
                    trashed: false,
                    district_id:'',
                    status: "active",
                },
                users: [],
                user: "",
                errors: [],
                districts: [],
                all_districts:[],
                district_ids: [],
                expandedDistricts: {},
                overflowDistricts: {},
                district_user: {
                    user_id: "",
                    district_ids: [],
                    deleted_district_ids: [],
                },
            };
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                if (from.name == "User.Edit") {
                    vm.meta.page = vm.$store.getters.current_page;
                } else {
                    vm.meta.page = 1;
                }
            });
        },
        mounted() {
            this.index();
            this.getDistrict();
            this.getAllDistricts();
        },
        methods: {
            search() {
                let vm = this;
                vm.meta.page = 1;
                vm.expandedDistricts = {};
                vm.overflowDistricts = {};
                vm.index();
            },
            getDistrictNames(user) {
                if (!user?.DistrictUsers?.length) return "";
                return user.DistrictUsers
                    .map((d) => d?.District?.district)
                    .filter(Boolean)
                    .join(", ");
            },
            toggleDistrict(userId) {
                this.expandedDistricts = {
                    ...this.expandedDistricts,
                    [userId]: !this.expandedDistricts[userId],
                };
                if (!this.expandedDistricts[userId]) {
                    this.$nextTick(() => this.checkDistrictOverflow());
                }
            },
            checkDistrictOverflow() {
                const overflow = {};
                this.users.forEach((user) => {
                    if (this.expandedDistricts[user.user_id]) {
                        overflow[user.user_id] = true;
                        return;
                    }
                    let el = this.$refs["districtText-" + user.user_id];
                    if (Array.isArray(el)) el = el[0];
                    if (!el) {
                        overflow[user.user_id] = false;
                        return;
                    }
                    // Compare clamped height vs full unclamped height
                    const clampedHeight = el.clientHeight;
                    el.classList.add("district-text-measure");
                    const fullHeight = el.scrollHeight;
                    el.classList.remove("district-text-measure");
                    overflow[user.user_id] = fullHeight > clampedHeight + 2;
                });
                this.overflowDistricts = overflow;
            },
            index() {
                let vm = this;
                vm.$store
                    .dispatch("post", { uri: "users/paginateUsers", data: vm.meta })
                    .then(function (response) {
                        vm.users = response.data.data.data;
                        vm.meta.totalRows = response.data.data.meta.total;
                        vm.meta.lastPage = response.data.data.meta.lastPage;
                        vm.meta.from = response.data.data.meta.from;
                        // const end = vm.meta.from + Number(vm.meta.per_page) - 1;
                        // vm.meta.to = end > vm.meta.totalRows ? vm.meta.totalRows : end;
                        vm.meta.to = response.data.data.meta.to;
                        vm.meta.maxPage = vm.meta.lastPage >= 3 ? 3 : vm.meta.lastPage;
                        vm.$nextTick(() => {
                            vm.checkDistrictOverflow();
                            // Re-check after layout settles (table column widths)
                            requestAnimationFrame(() => vm.checkDistrictOverflow());
                        });
                    })
                    .catch(function (error) {
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },

            edit(user) {
                this.$store.commit("setCurrentPage", parseInt(this.meta.page));
                this.$router.push("/users/" + user.user_id + "/edit");
            },
            district_assign(user) {
                let vm = this;
                vm.user = user;
                vm.district_ids = [];
                for (let i = 0; i < vm.user.DistrictUsers.length; i++) {
                    vm.district_ids.push({
                        district_id: user.DistrictUsers[i].District.district_id,
                        district: user.DistrictUsers[i].District.district,
                    });
                }
                vm.district_user.user_id = user.user_id;
            },
            submitdistricts() {
                let vm = this;
                let loader = vm.$loading.show();

                for (let i = 0; i < vm.district_ids.length; i++) {
                    vm.district_user.district_ids.push(vm.district_ids[i].district_id);
                }
                const districtIds = vm.district_ids.map((ele) => ele.district_id);
                const userdistrictIds = vm.user.DistrictUsers.map((ele) => ele.District.district_id);
                vm.district_user.deleted_district_ids = userdistrictIds.filter((item) => !districtIds.includes(item));

                let uri = { uri: "districtUsers/addMultipleDistrictUsers", data: vm.district_user };
                vm.$store
                    .dispatch("post", uri)
                    .then(function () {
                        loader.hide();
                        vm.$store.dispatch("success", "District is successfully created");
                        document.getElementById("closeModal").click();
                        vm.discard();
                        // vm.$router.push("/users");
                        vm.index();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },

            deleteUser(user) {
                let vm = this;
                let loader = vm.$loading.show();
                user.status = user.status == 1 ? 0 : 1;
                vm.$store
                    .dispatch("post", { uri: "users/deleteUser", data: user })
                    .then(function (response) {
                        loader.hide();
                        vm.$store.dispatch("success", response.data.message);
                        vm.index();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.error;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            confirmDelete(user) {
                this.confirm.name = user.name;
                this.confirm.user_id = user.user_id;
            },

            onPageChange(page) {
                this.meta.page = page;
                this.expandedDistricts = {};
                this.overflowDistricts = {};
                this.index();
            },
            sort(field) {
                this.meta.keyword = field;
                this.meta.order_by = this.meta.order_by == "asc" ? "desc" : "asc";
                this.expandedDistricts = {};
                this.overflowDistricts = {};
                this.index();
            },
            onPerPageChange() {
                this.meta.page = 1;
                this.expandedDistricts = {};
                this.overflowDistricts = {};
                this.index();
            },
            getDistrict() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "district/getDistricts" })
                    .then((response) => {
                        console.log("distt", response.data.data);
                        loader.hide();
                        vm.districts = response.data.data;
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            getAllDistricts() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "district/getAllDistricts" })
                    .then((response) => {
                        console.log("distt", response.data.data);
                        loader.hide();
                        vm.all_districts = response.data.data;
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            discard() {
                let vm = this;
                vm.user = "";
                vm.district_ids = [];
                vm.district_user.user_id = "";
                vm.district_user.district_ids = [];
                vm.district_user.deleted_district_ids = [];
            },
        },
    };
</script>
<style scoped>
    .status-filter {
        width: 130px;
        min-height: 38px;
    }

    .district-col {
        white-space: normal;
    }

    .district-text {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
        word-break: break-word;
        line-height: 1.35;
        max-height: calc(1.35em * 2);
    }

    .district-text.district-text-measure {
        display: block;
        -webkit-line-clamp: unset;
        max-height: none;
        overflow: visible;
    }

    .district-toggle {
        display: inline-block;
        margin-top: 2px;
        white-space: nowrap;
        font-size: 12px;
        color: #0d6efd;
        text-decoration: none;
    }

    .district-toggle:hover {
        text-decoration: underline;
    }

    .text-wrap {
        word-wrap: break-word;
        word-break: break-word;
        white-space: normal;
    }
</style>
